import { FeatureDomain, UpdateContactMutation } from '@akin-home/amplify';
import { showSuccessToast } from '@akin-home/toast/native';
import { sendBackgroundMessage } from '../../chat/functions';
import { intent_labels } from '../../chat/intent_labels';
import { postUpdateRecordLogEvent } from '../../logging/functions';
import { getCurrentUserID } from '../../users/functions';

type Params = UpdateContactMutation;

export const afterUpdateContact = ({ updateContact }: Params) => {
  sendBackgroundMessage(intent_labels.update_contact, {
    context: {
      contact: {
        id: updateContact?.id,
        name: updateContact?.name,
      },
    },
  });

  showSuccessToast({ text1: 'Contact Saved' });

  postUpdateRecordLogEvent({
    user_id: getCurrentUserID() as string,
    feature_domain: FeatureDomain.CONTACTS,
    data: {
      id: updateContact?.id as string,
      model: 'Contact',
    },
  });
};
